import { Pendo } from '@/model/pendo';

import { IUserInfo } from '../dto/auth/UserInfo/Interface';

const VOID_PENDO: Pendo = {
  getAccountId: () => '',
  getVisitorId: () => '',
  initialize: (_options) => null,
  isReady: () => false,
  track: (_trackType, _metadata) => null,
};

export const initPendo = (user: IUserInfo) => {
  const pendo = (window as any).pendo || VOID_PENDO;

  pendo.initialize({
    visitor: {
      id: user.userId ?? '',
      name: `${user.name?.first ?? ''} ${user.name?.last ?? ''}`,
      email: user.email,
    },
    account: {
      id: user.organizationId,
      name: user.organization?.name,
    },
  });
};

/**
 * Method to ensure the track event function is run after the Pendo Agent has loaded.
 *
 * @param trackType
 */
export const pendoTrack = (trackType: string): void => {
  const pendo = (window as any).pendo || VOID_PENDO;

  if (pendo.isReady && pendo.isReady()) {
    return pendo.track(trackType);
  }

  setTimeout(() => {
    pendoTrack(trackType);
  }, 500);
};
